import React from 'react'

import { Form, Col } from '_zari/core'

const FechaFormGroup = ({ value, onChange, isSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='FECHA' htmlFor='input-fecha' md={4} />
      <Col md={8}>
        <Form.InputDate name='inputFecha' value={value} onChange={onChange} id='input-fecha' disabled={isSubmitting} />
      </Col>
    </Form.Group>
  )
}

export default FechaFormGroup
